import { WarningIcon } from '@phosphor-icons/react';

interface ErrorProps {
  message: string;
  size: 'xs' | 'sm' | 'md';
}

export default function Error({ size, message }: ErrorProps) {
  const sizeClasses = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-base'
  };

  const gapClasses = {
    xs: 'gap-2',
    sm: 'gap-2.5',
    md: 'gap-3'
  };

  const iconSize = {
    xs: 18,
    sm: 20,
    md: 24
  };

  return (
    <div className={`flex items-center ${gapClasses[size]} text-misc-error`}>
      <WarningIcon size={iconSize[size]} weight="light" />
      <span className={`text-misc-error ${sizeClasses[size]}`}> {message}</span>
    </div>
  );
}
